import { commonUtil } from '@/util'
const request = {}

request.createRequest = function (shopData) {
  return {
    name: shopData.name,
    sortNumber: shopData.sortNumber
  }
}
export default { request }
